/**
 * OEM domain schema, derived from the generated Zod. No overrides.
 *
 * `oemListResponseSchema` composes its `results` from `oemSchema` rather than
 * reusing the generated element, so any future override applies to both the
 * paginated and the bare-array read (`useOEMs.ts` parses `oemSchema` directly)
 * instead of drifting between them.
 *
 * See ./README.md for the domain-conversion pattern.
 */
import { z } from 'zod';

import { OemsListResponse } from '~/data/generated/zod/oems/oems.zod';

export const oemSchema = OemsListResponse.shape.results.element;
export type OEM = z.infer<typeof oemSchema>;

export const oemListResponseSchema = OemsListResponse.extend({
  results: z.array(oemSchema),
});
